import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

let subRoutes = [
    {
      name: 'dashboard',
      path: '',
      component: () => import('@/views/main/dashboard')
    }
]
//获取/view/model下文件名,自动添加路由表
require.context("@/views/module", true, /\.vue$/).keys().map((item) => {
  let path = item.slice(1).replace(".vue", "").toLowerCase()
  let pathArr = path.slice(1).split('/')
  let name = ''
  pathArr.forEach((item, index) => {
    name += index == 0 ? item : item.slice(0, 1).toUpperCase() + item.slice(1)//userIndex
  })
  subRoutes.push({
    path,
    name,
    component: () => import(`@/views/module${item.slice(1)}`),
  })
})
// 路由配置表
const routes = [
  {
    name: 'index',
    path: '/',
    component: () => import('@/views/main/index'),
    meta: {
      title: '管理后台',
    },
    children: subRoutes
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/main/login'),
    meta: {
      title: '管理登录',
    }
  }
]
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
})
// // 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from代表从那个路径跳转而来
  // next 是一个函数，表示放行  next('/login) 强制跳转
  document.title = to.meta.title || '管理后台'
  const auth = Vue.prototype.$getAuth()
  if (to.path != '/login' && !auth.uuid){
     return next('/login')
  }
  next()
})
export default router;
